import http from '~/http/cryptomat';

export default ({
  state: {
    fees: [],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
    itemsPerPage: 0,
  },

  mutations: {
    SET_FEES(state, data) { state.fees = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_FILTERS(state, data) { state.filters = data; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    async loadFees({ getters, commit }) {
      const response = await http.get('/api/FeesLimits/GetFeesLimits', {
        ...getters.requestData,
      });
      const { data } = response;
      commit('SET_FEES', data);
      if (data.pages) {
        commit('SET_PAGES', data.pages);
      }
    },

    async updateFees(__store, data) {
      await http.post('/api/FeesLimits/ChangeFeeLimits', data);
    },
  },

  namespaced: true,
});
